import { UserRoundX } from "lucide-react";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { NoticeShell } from "./NoticeShell";

export function IncompleteNotice() {
  const [d, setD] = useState<any>(null);
  useEffect(() => { api.get("/students/incomplete").then((r) => setD(r.data)).catch(() => setD(null)); }, []);
  if (!d || !d.count) return null;
  const to = "/siswa?tab=siswa&filter=incomplete";
  return (
    <NoticeShell id="incomplete-notice" tone="amber" to={to} icon={<UserRoundX className="h-5 w-5" />}
      title={<p>Data siswa belum lengkap · <span data-testid="incomplete-count">{d.count}</span> siswa aktif</p>}
      action={<Link to={to} className="font-semibold text-amber-700 dark:text-amber-300 hover:underline" data-testid="incomplete-notice-link">Lengkapi sekarang →</Link>}>
      <div className="mt-2 flex flex-wrap gap-1.5">
        {d.items.map((it: any) => (
          <span key={it.id} className="rounded-full bg-white/70 dark:bg-white/10 border border-amber-200 dark:border-amber-800 px-2.5 py-0.5 text-xs" data-testid={`incomplete-item-${it.internal_id}`}>
            <span className="font-semibold">{it.name}</span> <span className="text-muted-foreground">· kurang: {it.missing.join(", ")}</span>
          </span>
        ))}
        {d.count > d.items.length && <span className="text-xs text-muted-foreground self-center">+{d.count - d.items.length} lainnya</span>}
      </div>
    </NoticeShell>
  );
}
